export default __webpack_public_path__ + "static/media/warning--low-flying-aircraft--g3.dd69f808.png";